module.exports = __webpack_public_path__ + "static/media/gp1.344099a0.webp";